import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, HStack, Link, Stack, Text, VStack } from '@chakra-ui/react';
import { Icon } from '@whitbread-eos/atoms';
import { formatAssetsUrl, formatDataTestId, useSemanticTypography, useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import FacilitiesModal from '../FacilitiesModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var headingLayoutStyles = {
  my: 'md'
};
var headingLegacyTypography = {
  fontSize: {
    base: 'xl',
    sm: 'lg'
  },
  fontWeight: 'bold',
  lineHeight: '3'
};
var headingSemanticTypography = {
  textStyle: 'heading-s'
};
var desktopSeeAllLinkLayoutStyles = {
  color: 'btnSecondaryEnabled',
  textDecoration: 'underline'
};
var desktopSeeAllLinkLegacyTypography = {
  fontSize: 'sm'
};
var desktopSeeAllLinkSemanticTypography = {
  textStyle: 'link-s-regular'
};
var facilityNameSemanticTypography = {
  textStyle: 'body-s-regular'
};
var desktopFacilityNameLegacyTypography = {
  fontSize: 'xs',
  lineHeight: '2'
};
var linkStyles = {
  fontSize: 'sm',
  color: 'btnSecondaryEnabled',
  textDecoration: 'underline'
};
var HotelFacilitiesList = _ref => {
  var isLessThanSm = _ref.isLessThanSm,
    _ref$isLessThanMd = _ref.isLessThanMd,
    isLessThanMd = _ref$isLessThanMd === void 0 ? false : _ref$isLessThanMd,
    _ref$isSoftBundlesVis = _ref.isSoftBundlesVisible,
    isSoftBundlesVisible = _ref$isSoftBundlesVis === void 0 ? false : _ref$isSoftBundlesVis;
  var _useStaticHotelInform = useStaticHotelInformation(),
    hotelFacilities = _useStaticHotelInform.hotelFacilities,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error;
  var getTypographyProps = useSemanticTypography();
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalVisible = _useState2[0],
    setIsModalVisible = _useState2[1];
  var isLessThanBreakpoint = isSoftBundlesVisible ? isLessThanMd : isLessThanSm;
  if (isLoading) {
    return _jsx(Text, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Text, {
      children: error.message
    });
  }
  if (!(hotelFacilities !== null && hotelFacilities !== void 0 && hotelFacilities.length)) {
    return null;
  }
  var visibleFacilities = hotelFacilities === null || hotelFacilities === void 0 ? void 0 : hotelFacilities.filter(item => item.isVisible).slice(0, isLessThanBreakpoint ? 4 : 6);
  var mobileFacilityNameTypographyProps = getTypographyProps({}, facilityNameSemanticTypography);
  var desktopFacilityNameTypographyProps = getTypographyProps(desktopFacilityNameLegacyTypography, facilityNameSemanticTypography);
  var headingContent = _jsxs(Box, _objectSpread(_objectSpread({}, headingLayoutStyles), {}, {
    "data-testid": "hdp_hotelFacilitiesText",
    children: [_jsx(Text, _objectSpread(_objectSpread({
      as: "span"
    }, getTypographyProps(headingLegacyTypography, headingSemanticTypography)), {}, {
      children: t('hoteldetails.hotel.facilities')
    })), !isLessThanBreakpoint && _jsx(Link, _objectSpread(_objectSpread(_objectSpread({}, desktopSeeAllLinkLayoutStyles), getTypographyProps(desktopSeeAllLinkLegacyTypography, desktopSeeAllLinkSemanticTypography)), {}, {
      onClick: openModal,
      pl: "sm",
      children: t('hoteldetails.seeall')
    }))]
  }));
  var itemsContent = _jsxs(Stack, {
    direction: isLessThanBreakpoint ? {
      base: 'column',
      md: 'row'
    } : {
      base: 'column',
      sm: 'row'
    },
    spacing: '0',
    overflowX: "auto",
    ml: {
      mobile: 0,
      sm: '-1.125rem',
      md: 0
    },
    mr: {
      mobile: 0,
      sm: '-2.125rem',
      md: 0
    },
    pl: {
      mobile: 0,
      sm: '1.125rem',
      md: 0
    },
    pr: {
      mobile: 0,
      sm: '2.125rem',
      md: 0
    },
    "data-testid": 'hdp_hotelFacilities',
    children: [visibleFacilities === null || visibleFacilities === void 0 ? void 0 : visibleFacilities.map((hotelFacility, index) => {
      var _hotelFacility$name, _hotelFacility$name2;
      return _jsx(Box, {
        children: isLessThanBreakpoint ? _jsxs(HStack, {
          cursor: "pointer",
          onClick: openModal,
          "data-testid": formatDataTestId(hotelFacility.name, 'HotelFacilitiesHStack'),
          children: [_jsx(Icon, {
            src: formatAssetsUrl(hotelFacility.icon),
            w: "6"
          }), _jsx(Text, _objectSpread(_objectSpread({}, mobileFacilityNameTypographyProps), {}, {
            children: hotelFacility === null || hotelFacility === void 0 || (_hotelFacility$name = hotelFacility.name) === null || _hotelFacility$name === void 0 ? void 0 : _hotelFacility$name.replace(/-/gm, '\u2011')
          }))]
        }) : _jsxs(VStack, {
          cursor: "pointer",
          onClick: openModal,
          "data-testid": formatDataTestId(hotelFacility.name, 'HotelFacilitiesVStack'),
          m: ['0 16px'],
          ml: index === 0 ? 0 : undefined,
          children: [_jsx(Icon, {
            src: formatAssetsUrl(hotelFacility.icon),
            cursor: "pointer",
            h: "6",
            onClick: openModal
          }), _jsx(Text, _objectSpread(_objectSpread({
            textAlign: "center"
          }, desktopFacilityNameTypographyProps), {}, {
            children: hotelFacility === null || hotelFacility === void 0 || (_hotelFacility$name2 = hotelFacility.name) === null || _hotelFacility$name2 === void 0 ? void 0 : _hotelFacility$name2.replace(/-/gm, '\u2011')
          }))]
        })
      }, hotelFacility.code);
    }), isLessThanBreakpoint && _jsx(Box, {
      children: _jsx(Link, _objectSpread(_objectSpread({}, linkStyles), {}, {
        mt: "md",
        display: "block",
        onClick: openModal,
        "data-testid": "hdp_mobileSeeAllHotelFacilities",
        children: t('hoteldetails.seeall')
      }))
    })]
  });
  var modalContent = _jsx(FacilitiesModal, {
    facilities: hotelFacilities,
    isModalVisible: isModalVisible,
    onModalClose: () => setIsModalVisible(false)
  });
  return _jsxs(_Fragment, {
    children: [headingContent, itemsContent, modalContent]
  });
  function openModal() {
    setIsModalVisible(true);
  }
};
export { HotelFacilitiesList };